/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function BookIcon(props: IconProps) {
    return (<IconWrapper {...props}>
            {<path d="M6 9.5C6 6.5 8.438 4 11.5 4h19C32.375 4 34 5.625 34 7.5v18c0 1.438-.875 2.625-2 3.188V33h.5c.813 0 1.5.688 1.5 1.5 0 .875-.687 1.5-1.5 1.5H11c-2.812 0-5-2.187-5-5V9.5M11 29c-1.125 0-2 .938-2 2 0 1.125.875 2 2 2h18v-4zm-2-2.562A5 5 0 0 1 11 26h19.5c.25 0 .5-.187.5-.5v-18c0-.25-.25-.5-.5-.5h-19C10.063 7 9 8.125 9 9.5zM15.5 11h11c.813 0 1.5.688 1.5 1.5 0 .875-.687 1.5-1.5 1.5h-11c-.875 0-1.5-.625-1.5-1.5 0-.812.625-1.5 1.5-1.5m0 5h11c.813 0 1.5.688 1.5 1.5 0 .875-.687 1.5-1.5 1.5h-11c-.875 0-1.5-.625-1.5-1.5 0-.812.625-1.5 1.5-1.5"/>}
        </IconWrapper>);
}
